export default function IconButton({ onClick, iconClass, alt, disabled }) {
  return (
    <button
      className="custom-button"
      type="button"
      title={alt || ''}
      onClick={onClick}
      disabled={disabled}
    ><i className={"bi " + iconClass} ></i></button>
  )
}